export const modulesKeyMap = {
  OPERATIONAL: "MODULE.OPERATIONAL",
  STRATEGIC: "MODULE.STRATEGIC",
  RISK_INSIGHTS: "MODULES.RISK_INSIGHTS",
  WORKFLOW: "MODULES.WORKFLOW",
  MANAGE_DATA: "MODULES.MANAGE_DATA",
  QUALITY_RISKS: "MODULES.QUALITY_RISKS"
};

export const tabsKeyMap = {
  OPERATIONAL_SUMMARY: "TABS.OPERATIONAL_SUMMARY",
  OPERATIONAL_MANAGEMENT: "TABS.OPERATIONAL_MANAGEMENT",
  OPERATIONAL_WORKFLOW: "TABS.OPERATIONAL_MANAGEMENT",
  STRATEGIC_SUMMARY: "TABS.STRATEGIC_SUMMARY",
  STRATEGIC_CAPACITY: "TABS.STRATEGIC_CAPACITY",
  RISK_INSIGHTS: "TABS.RISK_INSIGHTS",
  MANAGE_DATA: "TABS.MANAGE_DATA",
  QUALITY_COMPLAINT_DETAILS: "TABS.QUALITY_COMPLAINT_DETAILS"
};

export const viewsKeyMap = {
  OPERATIONAL_RISK_PRIORITIZATION_MATRIX:
    "VIEWS.OPERATIONAL_RISK_PRIORITIZATION_MATRIX",
  OPERATIONAL_RISK_COUNT_BY_PRODUCT: "VIEWS.OPERATIONAL_RISK_COUNT_BY_PRODUCT",
  OPERATIONAL_RISK_COUNT_BY_LOCATION:
    "VIEWS.OPERATIONAL_RISK_COUNT_BY_LOCATION",
  OPERATIONAL_RISK_ALERTS_TIMELINE: "VIEWS.OPERATIONAL_RISK_ALERTS_TIMELINE",
  OPERATIONAL_RISK_DETAILS: "VIEWS.OPERATIONAL_RISK_DETAILS",
  OPERATIONAL_WORKFLOW: "VIEWS.OPERATIONAL_RISK_DETAILS",
  STRATEGIC_KPIS: "VIEWS.STRATEGIC_KPIS",
  STRATEGIC_RISK_PRIORITIZATION_MATRIX:
    "VIEWS.STRATEGIC_RISK_PRIORITIZATION_MATRIX",
  STRATEGIC_RISK_SCORE_COMPONENTS: "VIEWS.STRATEGIC_RISK_SCORE_COMPONENTS",
  STRATEGIC_RISK_TYPE_TRENDAREA: "VIEWS.STRATEGIC_RISK_TYPE_TRENDAREA",
  STRATEGIC_CAPACITY_KPIS: "VIEWS.STRATEGIC_CAPACITY_KPIS",
  STRATEGIC_CAPACITY_ASSESSMENT: "VIEWS.STRATEGIC_CAPACITY_ASSESSMENT",
  RISK_INSIGHTS_TREND_LINE: "VIEWS.RISK_INSIGHTS_TREND_LINE",
  MANAGE_DATA_DC_CONTINGENCY: "VIEWS.MANAGE_DATA_DC_CONTINGENCY",
  MANAGE_DATA_SUPPLIER_CAPACITY: "VIEWS.MANAGE_DATA_SUPPLIER_CAPACITY",
  MANAGE_DATA_TIER2_NETWORK: "VIEWS.MANAGE_DATA_TIER2_NETWORK",
  QUALITY_RISKS_QCD_DATE: "VIEWS.QUALITY_RISKS_QCD_DATE",
  QUALITY_RISKS_QCD_PRODUCT: "VIEWS.QUALITY_RISKS_QCD_PRODUCT",
  QUALITY_RISKS_QCD_LOCATION: "VIEWS.QUALITY_RISKS_QCD_LOCATION",
  QUALITY_RISKS_QCD_INCIDENT_TYPE: "VIEWS.QUALITY_RISKS_QCD_INCIDENT_TYPE",
  QUALITY_RISKS_QCD_ISSUE_TYPE: "VIEWS.QUALITY_RISKS_QCD_ISSUE_TYPE",
};

export const actionsKeyMap = {
  CREATE_NEW_RISK_CASE: "ACTION.CREATE_NEW_RISK_CASE",
  RUN_SCENARIO: "ACTION.RUN_SCENARIO",
  RISK_MITIGATION: "ACTION.RISK_MITIGATION",
  VIEW_TABLE: "ACTION.VIEW_TABLE",
  VIEW_CHART: "ACTION.VIEW_CHART",
  VIEW_ALT_CHART: "ACTION.VIEW_ALT_CHART",
  DOWNLOAD: "ACTION.DOWNLOAD",
  PRINT: "ACTION.PRINT",
};

// const getModulesFromView = (view) => {
//   const operationalModuleViews = [
//     viewsKeyMap.RISK_PRIORITIZATION_MATRIX,
//     viewsKeyMap.RISK_COUNT_BY_PRODUCT,
//     viewsKeyMap.RISK_COUNT_BY_LOCATION,
//     viewsKeyMap.RISK_ALERTS_TIMELINE,
//     viewsKeyMap.RISK_DETAILS,
//   ]

//   const strategicModuleViews = [
//     viewsKeyMap.STRATEGIC_KPIS,
//     viewsKeyMap.STRATEGIC_RISK_PRIORITIZATION_MATRIX,
//     viewsKeyMap.RISK_SCORE_COMPONENTS,
//     viewsKeyMap.RISK_TYPE_TRENDLINE,
//     viewsKeyMap.STRATEGIC_CAPACITY_KPIS,
//     viewsKeyMap.CAPACITY_ASSESSMENT,
//   ]

//   const insightsModuleViews = [
//     viewsKeyMap.RISK_INSIGHTS_TREND_LINE
//   ]
// };

const getTabsFromViews = (views) => {
  const operationalSummaryTab = [
    viewsKeyMap.OPERATIONAL_RISK_PRIORITIZATION_MATRIX,
    viewsKeyMap.OPERATIONAL_RISK_COUNT_BY_PRODUCT,
    viewsKeyMap.OPERATIONAL_RISK_COUNT_BY_LOCATION,
    viewsKeyMap.OPERATIONAL_RISK_ALERTS_TIMELINE,
  ];

  const operationalManagementTab = [viewsKeyMap.OPERATIONAL_RISK_DETAILS];
  const operationalWorkflowTab = [viewsKeyMap.OPERATIONAL_WORKFLOW];

  const strategicSummaryTab = [
    viewsKeyMap.STRATEGIC_KPIS,
    viewsKeyMap.STRATEGIC_RISK_PRIORITIZATION_MATRIX,
    viewsKeyMap.STRATEGIC_RISK_SCORE_COMPONENTS,
    viewsKeyMap.STRATEGIC_RISK_TYPE_TRENDAREA,
  ];

  const strategicCapacityTab = [
    viewsKeyMap.STRATEGIC_CAPACITY_KPIS,
    viewsKeyMap.STRATEGIC_CAPACITY_ASSESSMENT,
  ];

  const insightModuleTabs = [];

  const manageDataModuleTabs = [];

  const qualityRiskModuleTabs = [
    viewsKeyMap.QUALITY_RISKS_QCD_DATE,
    viewsKeyMap.QUALITY_RISKS_QCD_PRODUCT,
    viewsKeyMap.QUALITY_RISKS_QCD_LOCATION,
    viewsKeyMap.QUALITY_RISKS_QCD_INCIDENT_TYPE,
    viewsKeyMap.QUALITY_RISKS_QCD_ISSUE_TYPE
  ]

  const hasTabs = {
    [tabsKeyMap.OPERATIONAL_SUMMARY]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.OPERATIONAL_MANAGEMENT]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.OPERATIONAL_WORKFLOW]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.STRATEGIC_SUMMARY]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.STRATEGIC_CAPACITY]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.RISK_INSIGHTS]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.MANAGE_DATA]: {
      hasAccess: false,
      views: [],
    },
    [tabsKeyMap.QUALITY_COMPLAINT_DETAILS]: {
      hasAccess: false,
      views: []
    }
  };

  views.forEach((view) => {
    if (operationalSummaryTab.indexOf(view) > -1) {
      const tabObj = hasTabs[tabsKeyMap.OPERATIONAL_SUMMARY];
      tabObj.hasAccess = true;

      if (tabObj.views.indexOf(view) === -1) {
        tabObj.views.push(view);
      }
    }

    if (operationalManagementTab.indexOf(view) > -1) {
      const tabObj = hasTabs[tabsKeyMap.OPERATIONAL_MANAGEMENT];
      tabObj.hasAccess = true;

      if (tabObj.views.indexOf(view) === -1) {
        tabObj.views.push(view);
      }
    }

    if (operationalWorkflowTab.indexOf(view) > -1) {
      const tabObj = hasTabs[tabsKeyMap.OPERATIONAL_WORKFLOW];
      tabObj.hasAccess = true;

      if (tabObj.views.indexOf(view) === -1) {
        tabObj.views.push(view);
      }
    }

    if (strategicSummaryTab.indexOf(view) > -1) {
      const tabObj = hasTabs[tabsKeyMap.STRATEGIC_SUMMARY];
      tabObj.hasAccess = true;

      if (tabObj.views.indexOf(view) === -1) {
        tabObj.views.push(view);
      }
    }

    if (strategicCapacityTab.indexOf(view) > -1) {
      const tabObj = hasTabs[tabsKeyMap.STRATEGIC_CAPACITY];
      tabObj.hasAccess = true;

      if (tabObj.views.indexOf(view) === -1) {
        tabObj.views.push(view);
      }
    }

    if (qualityRiskModuleTabs.indexOf(view) > -1) {
      const tabObj = hasTabs[tabsKeyMap.QUALITY_COMPLAINT_DETAILS];
      tabObj.hasAccess = true;

      if (tabObj.views.indexOf(view) === -1) {
        tabObj.views.push(view);
      }
    }
  });

  return hasTabs;
};

const workflowModule = {
  authKey: modulesKeyMap.WORKFLOW,
  label: "Workflow",
  hasAccess: false,
  tabs: [],
  views: [
    {
      authKey: viewsKeyMap.OPERATIONAL_RISK_DETAILS,
      label: "Workflow",
      hasAccess: false,
    },
  ],
};

const qualityRiskModule = {
  authKey: modulesKeyMap.QUALITY_RISKS,
  label: "Operational Risks",
  hasAccess: false,
  tabs: [
    {
      authKey: tabsKeyMap.QUALITY_COMPLAINT_DETAILS,
      label: "Summary",
      hasAccess: false,
      views: [
        {
          authKey: viewsKeyMap.QUALITY_RISKS_QCD_DATE,
          label: "Complaints by Date Chart",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.QUALITY_RISKS_QCD_PRODUCT,
          label: "Complaints by Product",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.QUALITY_RISKS_QCD_LOCATION,
          label: "Complaints by Location",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.QUALITY_RISKS_QCD_INCIDENT_TYPE,
          label: "Complaints by Incident Type",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.QUALITY_RISKS_QCD_ISSUE_TYPE,
          label: "Complaints by Issue Type",
          hasAccess: false,
        },
      ],
    }]
  }


const operationalModule = {
  authKey: modulesKeyMap.OPERATIONAL,
  label: "Operational Risks",
  hasAccess: false,
  tabs: [
    {
      authKey: tabsKeyMap.OPERATIONAL_SUMMARY,
      label: "Summary",
      hasAccess: false,
      views: [
        {
          authKey: viewsKeyMap.RISK_PRIORITIZATION_MATRIX,
          label: "Risk Prioritization Matrix",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.RISK_COUNT_BY_PRODUCT,
          label: "Risk Count by Product",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.RISK_COUNT_BY_LOCATION,
          label: "Risk Count by Location",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.RISK_ALERTS_TIMELINE,
          label: "Risk Alerts Timeline",
          hasAccess: false,
        },
      ],
    },
    {
      authKey: tabsKeyMap.OPERATIONAL_MANAGEMENT,
      label: "Management",
      hasAccess: false,
      views: [
        {
          authKey: viewsKeyMap.RISK_DETAILS,
          label: "Risk Details",
          hasAccess: false,
        },
      ],
    },
  ],
};

const strategicModule = {
  authKey: modulesKeyMap.STRATEGIC,
  label: "Strategic Risks",
  hasAccess: false,
  tabs: [
    {
      authKey: tabsKeyMap.STRATEGIC_SUMMARY,
      label: "Summary",
      hasAccess: false,
      views: [
        {
          authKey: viewsKeyMap.STRATEGIC_KPIS,
          label: "KPIS",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.STRATEGIC_RISK_PRIORITIZATION_MATRIX,
          label: "Strategic Risk Prioritization Matrix",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.RISK_SCORE_COMPONENTS,
          label: "Risk Score Components",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.RISK_TYPE_TRENDLINE,
          label: "Risk Type Trendline",
          hasAccess: false,
        },
      ],
    },
    {
      authKey: tabsKeyMap.STRATEGIC_CAPACITY,
      label: "Capacity",
      hasAccess: false,
      views: [
        {
          authKey: viewsKeyMap.STRATEGIC_CAPACITY_KPIS,
          label: "KPIS",
          hasAccess: false,
        },
        {
          authKey: viewsKeyMap.CAPACITY_ASSESSMENT,
          label: "Capacity Assessment",
          hasAccess: false,
        },
      ],
    },
  ],
};

const riskInsightsModule = {
  authKey: modulesKeyMap.RISK_INSIGHTS,
  label: "Risk Insights",
  hasAccess: false,
  tabs: [],
  views: [
    {
      authKey: viewsKeyMap.RISK_INSIGHTS_TREND_LINE,
      label: "Risk Trend Line",
      hasAccess: false,
    },
  ],
};

const manageDataModule = {
  authKey: modulesKeyMap.MANAGE_DATA,
  label: "Manage Data",
  hasAccess: false,
  tabs: [],
  views: [
    {
      authKey: viewsKeyMap.MANAGE_DATA_DC_CONTINGENCY,
      label: "DC Contingency",
      hasAccess: false,
    },
    {
      authKey: viewsKeyMap.MANAGE_DATA_SUPPLIER_CAPACITY,
      label: "Supplier Capacity",
      hasAccess: false,
    },
    {
      authKey: viewsKeyMap.MANAGE_DATA_TIER2_NETWORK,
      label: "Tier 2 Network",
      hasAccess: false,
    },
  ],
};

export const overallActions = [
  {
    authKey: actionsKeyMap.CREATE_NEW_RISK_CASE,
    label: "Create New Risk Case",
    hasAccess: false,
  },
  {
    authKey: actionsKeyMap.RUN_SCENARIO,
    label: "Run Scenario",
    hasAccess: false,
  },
  {
    authKey: actionsKeyMap.RISK_MITIGATION,
    label: "Submit",
    hasAccess: false,
  },
];
// SAVE_PREFERENCES
// UNCONSTRAINED_CAPACITY_VIEW

export const commonActions = [
  {
    authKey: actionsKeyMap.VIEW_TABLE,
    label: "View Table",
  },
  {
    authKey: actionsKeyMap.VIEW_CHART,
    label: "View Chart",
  },
  {
    authKey: actionsKeyMap.VIEW_ALT_CHART,
    label: "View Alt Chart",
  },
  {
    authKey: actionsKeyMap.DOWNLOAD,
    label: "Download",
  },
  {
    authKey: actionsKeyMap.PRINT,
    label: "Print",
  },
];

export const createAccessArray = (views = [], actions = []) => {
  const newWorkflowModule = JSON.parse(JSON.stringify(workflowModule));
  const newOpModule = JSON.parse(JSON.stringify(operationalModule));
  const newStrModule = JSON.parse(JSON.stringify(strategicModule));
  const newRiskModule = JSON.parse(JSON.stringify(riskInsightsModule));
  const newManageDataModule = JSON.parse(JSON.stringify(manageDataModule));
  const newQualityRisksModule = JSON.parse(JSON.stringify(qualityRiskModule));
  const actionModule = JSON.parse(JSON.stringify(overallActions));

  const hasTabs = getTabsFromViews(views);
  const authorizedModules = [];
  const authorizedTabs = [];
  if (hasTabs[tabsKeyMap.OPERATIONAL_SUMMARY].hasAccess) {
    newOpModule.hasAccess = true;
    newOpModule.tabs[0].hasAccess = true;

    const tabViews = hasTabs[tabsKeyMap.OPERATIONAL_SUMMARY].views;

    newOpModule.tabs[0].views.forEach((view) => {
      if (tabViews.indexOf(view.authKey) > -1) {
        view.hasAccess = true;
      }
    });

    if (authorizedModules.indexOf(newOpModule.authKey) === -1) {
      authorizedModules.push(newOpModule.authKey);
    }

    authorizedTabs.push(tabsKeyMap.OPERATIONAL_SUMMARY);
  }

  if (hasTabs[tabsKeyMap.OPERATIONAL_MANAGEMENT].hasAccess) {
    newOpModule.hasAccess = true;
    newOpModule.tabs[1].hasAccess = true;

    const tabViews = hasTabs[tabsKeyMap.OPERATIONAL_MANAGEMENT].views;

    newOpModule.tabs[1].views.forEach((view) => {
      if (tabViews.indexOf(view.authKey) > -1) {
        view.hasAccess = true;
      }
    });

    if (authorizedModules.indexOf(newOpModule.authKey) === -1) {
      authorizedModules.push(newOpModule.authKey);
    }

    authorizedTabs.push(tabsKeyMap.OPERATIONAL_MANAGEMENT);
  }

  if (hasTabs[tabsKeyMap.OPERATIONAL_WORKFLOW].hasAccess) {
    newWorkflowModule.hasAccess = true;

    authorizedModules.push(newWorkflowModule.authKey);

    newWorkflowModule.views[0].hasAccess = true;
  }

  if (hasTabs[tabsKeyMap.STRATEGIC_SUMMARY].hasAccess) {
    newStrModule.hasAccess = true;
    newStrModule.tabs[0].hasAccess = true;

    const tabViews = hasTabs[tabsKeyMap.STRATEGIC_SUMMARY].views;

    newStrModule.tabs[0].views.forEach((view) => {
      if (tabViews.indexOf(view.authKey) > -1) {
        view.hasAccess = true;
      }
    });

    if (authorizedModules.indexOf(newStrModule.authKey) === -1) {
      authorizedModules.push(newStrModule.authKey);
    }

    authorizedTabs.push(tabsKeyMap.STRATEGIC_SUMMARY);
  }

  if (hasTabs[tabsKeyMap.STRATEGIC_CAPACITY].hasAccess) {
    newStrModule.hasAccess = true;
    newStrModule.tabs[1].hasAccess = true;

    const tabViews = hasTabs[tabsKeyMap.STRATEGIC_CAPACITY].views;

    newStrModule.tabs[1].views.forEach((view) => {
      if (tabViews.indexOf(view.authKey) > -1) {
        view.hasAccess = true;
      }
    });

    if (authorizedModules.indexOf(newStrModule.authKey) === -1) {
      authorizedModules.push(newStrModule.authKey);
    }

    authorizedTabs.push(tabsKeyMap.STRATEGIC_CAPACITY);
  }

  if (views.indexOf(viewsKeyMap.RISK_INSIGHTS_TREND_LINE) > -1) {
    newRiskModule.hasAccess = true;

    authorizedModules.push(newRiskModule.authKey);

    newRiskModule.views[0].hasAccess = true;
  }

  if (views.indexOf(viewsKeyMap.MANAGE_DATA_DC_CONTINGENCY) > -1
    || views.indexOf(viewsKeyMap.MANAGE_DATA_SUPPLIER_CAPACITY) > -1
    || views.indexOf(viewsKeyMap.MANAGE_DATA_TIER2_NETWORK) > -1) {
    
    newManageDataModule.hasAccess = true;

    authorizedModules.push(newManageDataModule.authKey);

    if(views.indexOf(viewsKeyMap.MANAGE_DATA_DC_CONTINGENCY) > -1) {
      newManageDataModule.views[0].hasAccess = true;
    } 

    if(views.indexOf(viewsKeyMap.MANAGE_DATA_SUPPLIER_CAPACITY) > -1) {
      newManageDataModule.views[1].hasAccess = true;
    }

    if(views.indexOf(viewsKeyMap.MANAGE_DATA_TIER2_NETWORK) > -1) {
      newManageDataModule.views[2].hasAccess = true;
    }
  }

  if (hasTabs[tabsKeyMap.QUALITY_COMPLAINT_DETAILS].hasAccess) {
    newQualityRisksModule.hasAccess = true;
    newQualityRisksModule.tabs[0].hasAccess = true;

    const tabViews = hasTabs[tabsKeyMap.QUALITY_COMPLAINT_DETAILS].views;

    newQualityRisksModule.tabs[0].views.forEach((view) => {
      if (tabViews.indexOf(view.authKey) > -1) {
        view.hasAccess = true;
      }
    });

    if (authorizedModules.indexOf(newQualityRisksModule.authKey) === -1) {
      authorizedModules.push(newQualityRisksModule.authKey);
    }

    authorizedTabs.push(tabsKeyMap.QUALITY_COMPLAINT_DETAILS);
  }

  const actionAuthKeys = [];
  actions.forEach((action) => {
    actionAuthKeys.push(action);
  });

  return {
    modules: [newOpModule, newStrModule, newRiskModule, newManageDataModule],
    moduleAuthKeys: authorizedModules,
    tabAuthKeys: authorizedTabs,
    viewAuthKeys: views,
    actions: actions,
    actionAuthKeys: actionAuthKeys,
  };
};

export const moduleBaseState = {
  [modulesKeyMap.OPERATIONAL]: false,
  [modulesKeyMap.STRATEGIC]: false,
  [modulesKeyMap.RISK_INSIGHTS]: false,
  [modulesKeyMap.MANAGE_DATA]: false,
};

export const tabsBaseState = {
  [tabsKeyMap.OPERATIONAL_SUMMARY]: false,
  [tabsKeyMap.OPERATIONAL_MANAGEMENT]: false,
  [tabsKeyMap.STRATEGIC_SUMMARY]: false,
  [tabsKeyMap.STRATEGIC_CAPACITY]: false,
};

export const viewsBaseState = {
  [viewsKeyMap.OPERATIONAL_RISK_PRIORITIZATION_MATRIX]: false,
  [viewsKeyMap.OPERATIONAL_RISK_COUNT_BY_PRODUCT]: false,
  [viewsKeyMap.OPERATIONAL_RISK_COUNT_BY_LOCATION]: false,
  [viewsKeyMap.OPERATIONAL_RISK_ALERTS_TIMELINE]: false,
  [viewsKeyMap.OPERATIONAL_RISK_DETAILS]: false,
  [viewsKeyMap.STRATEGIC_KPIS]: false,
  [viewsKeyMap.STRATEGIC_RISK_PRIORITIZATION_MATRIX]: false,
  [viewsKeyMap.STRATEGIC_RISK_SCORE_COMPONENTS]: false,
  [viewsKeyMap.STRATEGIC_RISK_TYPE_TRENDAREA]: false,
  [viewsKeyMap.STRATEGIC_CAPACITY_KPIS]: false,
  [viewsKeyMap.STRATEGIC_CAPACITY_ASSESSMENT]: false,
  [viewsKeyMap.MANAGE_DATA]: false,
};

export const actionsBaseState = {
  [actionsKeyMap.CREATE_NEW_RISK_CASE]: false,
  [actionsKeyMap.RUN_SCENARIO]: false,
  [actionsKeyMap.RISK_MITIGATION]: false,
  [actionsKeyMap.VIEW_TABLE]: false,
  [actionsKeyMap.VIEW_CHART]: false,
  [actionsKeyMap.VIEW_ALT_CHART]: false,
  [actionsKeyMap.DOWNLOAD]: false,
  [actionsKeyMap.PRINT]: false,
};

export const moduleAllState = {
  [modulesKeyMap.OPERATIONAL]: true,
  [modulesKeyMap.STRATEGIC]: true,
  [modulesKeyMap.RISK_INSIGHTS]: true,
  [modulesKeyMap.MANAGE_DATA]: true,
};

export const tabsAllState = {
  [tabsKeyMap.OPERATIONAL_SUMMARY]: true,
  [tabsKeyMap.OPERATIONAL_MANAGEMENT]: true,
  [tabsKeyMap.STRATEGIC_SUMMARY]: true,
  [tabsKeyMap.STRATEGIC_CAPACITY]: true,
};

export const viewsAllState = {
  [viewsKeyMap.OPERATIONAL_RISK_PRIORITIZATION_MATRIX]: true,
  [viewsKeyMap.OPERATIONAL_RISK_COUNT_BY_PRODUCT]: true,
  [viewsKeyMap.OPERATIONAL_RISK_COUNT_BY_LOCATION]: true,
  [viewsKeyMap.OPERATIONAL_RISK_ALERTS_TIMELINE]: true,
  [viewsKeyMap.OPERATIONAL_RISK_DETAILS]: true,
  [viewsKeyMap.STRATEGIC_KPIS]: true,
  [viewsKeyMap.STRATEGIC_RISK_PRIORITIZATION_MATRIX]: true,
  [viewsKeyMap.STRATEGIC_RISK_SCORE_COMPONENTS]: true,
  [viewsKeyMap.STRATEGIC_RISK_TYPE_TRENDAREA]: true,
  [viewsKeyMap.STRATEGIC_CAPACITY_KPIS]: true,
  [viewsKeyMap.STRATEGIC_CAPACITY_ASSESSMENT]: true,
  [viewsKeyMap.MANAGE_DATA]: true,
};

export const actionsAllState = {
  [actionsKeyMap.CREATE_NEW_RISK_CASE]: true,
  [actionsKeyMap.RUN_SCENARIO]: true,
  [actionsKeyMap.RISK_MITIGATION]: true,
  [actionsKeyMap.VIEW_TABLE]: true,
  [actionsKeyMap.VIEW_CHART]: true,
  [actionsKeyMap.VIEW_ALT_CHART]: true,
  [actionsKeyMap.DOWNLOAD]: true,
  [actionsKeyMap.PRINT]: true,
};

export const modules = [
  operationalModule,
  strategicModule,
  riskInsightsModule,
  manageDataModule,
];
